import React, { useState } from "react";
import { useSelector } from "react-redux";
import useFillFavorites from "../../hooks/common/useFillFavorites";
import GamesItems from "../mui/games_items/GamesItems";

export default function FavoritesGames() {
  const games = useSelector((state) => state.games.favoriteGames);
  const [loader, setLoader] = useState(true);
  useFillFavorites(0, setLoader);

  return <GamesItems games={games} loader={loader} noGames />;
}
